export enum Localization {
  Poland = 'pl',
  Global = 'global',
}
